import { useState } from "react";
import { ChevronDown, Star } from "lucide-react";
import { Reveal } from "@/components/bits";
import { PRODUCT_FAQS } from "@/config/product";

// PDP FAQ — curated highest-intent questions, same white accordion-card
// styling as the site FAQ. Indexes into PRODUCT_FAQS (config/product.js).
const FAQ_PICKS = [0, 1, 4, 7, 8, 11].map((i) => PRODUCT_FAQS[i]);
export default function PdpFaq({ onOpenSizeGuide }) {
  const [open, setOpen] = useState(null);

  return (
    <section
      data-testid="pdp-faq"
      className="px-4 py-10 sm:py-14 max-w-2xl mx-auto w-full"
    >
      <Reveal>
        <div
          data-testid="faq-social-proof"
          className="relative rounded-3xl overflow-hidden border-2 border-ink mb-8"
        >
          <img
            src="/images/lifestyle-1-800.webp"
            srcSet="/images/lifestyle-1-480.webp 480w, /images/lifestyle-1-800.webp 800w, /images/lifestyle-1.webp 1200w"
            sizes="(max-width: 639px) calc(100vw - 32px), 1088px"
            alt="Three nurses on shift wearing POSSO clogs in Pink, Yellow and Light Blue"
            className="w-full h-auto select-none"
            loading="lazy"
            draggable="false"
          />
          <span
            data-testid="faq-waitlist-badge"
            className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-ivory/90 backdrop-blur-sm border-2 border-ink px-3 py-1.5"
          >
            <Star className="w-3.5 h-3.5 text-[#FFB800] fill-[#FFB800]" strokeWidth={2} />
            <span className="font-body font-bold text-[11px] tracking-wide uppercase text-ink">
              1,000+ Australian healthcare workers on the waitlist
            </span>
          </span>
        </div>
        <p className="font-body font-bold text-[11px] tracking-[0.22em] uppercase text-ink/50">
          QUICK ANSWERS
        </p>
        <h2 className="mt-3 font-display uppercase leading-[0.95] text-[8.5vw] sm:text-4xl">
          FAQs
        </h2>
        <div className="mt-6 space-y-2">
          {FAQ_PICKS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="rounded-2xl border-2 border-ink/10 bg-white"
              >
                <button
                  data-testid={`pdp-faq-question-${i + 1}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-4 py-4 text-left"
                >
                  <span className="font-display uppercase tracking-wide text-base leading-tight">
                    {f.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 shrink-0 transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    strokeWidth={2.5}
                  />
                </button>
                {isOpen && (
                  <div className="px-4 pb-4">
                    <p
                      data-testid={`pdp-faq-answer-${i + 1}`}
                      className="text-sm sm:text-base text-ink/70 max-w-md"
                    >
                      {f.a}
                    </p>
                    {f.sizeGuide && (
                      <button
                        data-testid="pdp-faq-size-guide-link"
                        onClick={onOpenSizeGuide}
                        className="mt-2 inline-block text-sm font-semibold underline decoration-[#FF6BAA] decoration-2 underline-offset-2 text-ink"
                      >
                        Open the size guide
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
}
